import { render, staticRenderFns } from "./PermissionDeniedPage.vue?vue&type=template&id=060d3479&scoped=true&"
import script from "./PermissionDeniedPage.vue?vue&type=script&lang=js&"
export * from "./PermissionDeniedPage.vue?vue&type=script&lang=js&"
import style0 from "./PermissionDeniedPage.vue?vue&type=style&index=0&id=060d3479&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060d3479",
  null
  
)

export default component.exports